var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"max-height":"150","contain":"","src":_vm.banner,"alt":"Valenz","position":"right"}})
}
var staticRenderFns = []

export { render, staticRenderFns }